import { render, staticRenderFns } from "./SearchAuthorList.vue?vue&type=template&id=1bcc8e41&scoped=true"
import script from "./SearchAuthorList.vue?vue&type=script&lang=js"
export * from "./SearchAuthorList.vue?vue&type=script&lang=js"
import style0 from "./SearchAuthorList.vue?vue&type=style&index=0&id=1bcc8e41&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcc8e41",
  null
  
)

export default component.exports